 <ng-container *ngIf="environment.ProdottiAddOn['SezioniCodiciSconto'] && Item && (!id || Item?.id == id )">
   <app-sector-viewer [DropdownSources]="{}" (OnFilter)="FilterHandler($event)" (OnChange)="ChangeHandler($event)" [(Campi)]="environment.ProdottiAddOn['SezioniCodiciSconto']" [(Oggetto)]="Item"></app-sector-viewer>
 </ng-container>
 <div class="card">
   <div class="card-body">
     <div *ngIf="UnitaDiMisura && UnitaDiMisura.length > 0" class="row">
       <div class="col-12">
         <h5>Inserire uno o piu prezzi nella lista</h5>
       </div>
       <div class="input-group col-sm-12 col-md-4" *ngIf="UnitaDiMisura.length > 1">
         <div>
           <label class="input-group-text" >{{'prodotti.um' | translate}}</label>
         </div>
         <ng-multiselect-dropdown [settings]="unitadropdownSettings" *ngIf="UnitaDiMisura && UnitaDiMisura.length > 0" style="width: 80%; " [placeholder]="'prodotti.um' | translate" name="um" [data]="UnitaDiMisura"
                                  [(ngModel)]="UnitaDiMisuraSelezionata">
         </ng-multiselect-dropdown>
       </div>
       <div class="input-group col-sm-6 col-md-3">
         <div class="">
           <label class="input-group-text">{{'prodotti.Price' | translate}}</label>
         </div>
         <input type="number" [(ngModel)]="prezzo" name="prezzo" class="form-control">
       </div>
       <div class="col-sm-12 col-md-1" *ngIf="environment.ProdottiAddOn['iva']">
         <div class="form-group">
           <input [(ngModel)]="Item.iva" type="number" min="0" max="100" step="1" class="form-control" id="iva" placeholder="{{'prodotti.iva' | translate}}">
         </div>
       </div>
       <div class=" mt-3 mt-md-0 d-flex align-items-center p-1">
         <button class="btn btn-outline-success rounded-pill" style="width: 100%;" (click)="addPrezzo()" type="button">{{'prodotti.aggiungi' | translate}}</button>
       </div>
     </div>
     <div *ngIf="Item" class="table-responsive">
       <table class="table bg-white table-hover align-middle mb-0 no-wrap">
         <thead>
         <tr>
           <th >{{'prodotti.Price' | translate}}</th>
           <th scope="col">{{'prodotti.um' | translate}}</th>
           <th scope="col">{{'prodotti.Actions' | translate}}</th>
         </tr>
         </thead>
         <tbody>
         <tr *ngFor="let co of Item?.prezzi">
           <td>
             <!-- <img [src]='co.Imagepath' class="rounded-circle mr-2" alt="" height="45" width="45"> -->
             <span class="text-dark font-medium font-16">
                                <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                                  <i class="fas fa-euro-sign"></i>
                                </span>
               {{ co.prezzo}} €
                              </span>
           </td>
           <td class="align-middle">
                              <span>
                                <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                                  <i class="fas fa-barcode"></i>
                                </span>
                                {{ co.umlabel}}
                              </span>
           </td>
           <td class="align-middle">
             <a href="javascript:void(0)" class="link text-danger font-16 font-weight-bold" (click)='deletePrezzo(co)'>
               <i-feather name="trash-2" class="feather-sm"></i-feather>
             </a>
           </td>
         </tr>
         </tbody>
       </table>
     </div>
   </div>
 </div>
 <div class="card">
   <div class="card-body">
     <div class="form-actions ml-auto m-t-40">
       <app-stampa *ngIf="Item?.stampe?.length > 0" [Stampe]="Item.stampe"></app-stampa>
       <button type="submit" class="btn btn-success" (click)="saveClick()">
         <i class="fa fa-check"></i> {{'prodotti.Save' | translate}}
       </button>
       <button type="submit" class="btn btn-success" (click)="saveClick(true)">
         <i class="fa fa-check"></i> {{'saveAndClose' | translate}}
       </button>

       <button type="button" class="btn btn-dark" (click)="cancel()">{{'prodotti.cancel' | translate}}</button>
     </div>

   </div>
 </div>
